// React
import React, { Fragment } from 'react';
// Material-UI
import { Button, useMediaQuery } from "@material-ui/core";
import AddIcon from '@material-ui/icons/Add';
// Otras libs

// Componentes
import FloatingAction from 'componentes/FloatingAction';
import { useLocalization } from 'contexto/localization/useLocalization';
import SplitButton from 'componentes/SplitButton';
// Vistas

// Servicios

// Funciones

// Hooks


/**
 * Especifica la función a ser ejecutada al hacer click en botón
 * @callback OnClick
 * @returns {void}
 */

/**
 * 
 * @typedef {Object} Props
 * @property {boolean} disabled Si botón se encuentra deshabilitado
 * @property {boolean} hidden Si se debe mostrar el botón
 * @property {boolean?} onlyOptions Si es `true`, el botón principal será ocultado
 * @property {JSX.Element[]} options Opciones secundarias de botón
 * @property {OnClick} onClick Evento al presionar botón
 */

/**
 * Sección
 * @param {Props} props
 * @param {ChildrenFn} props.children
 * @returns 
 */
export const BotonNuevo = ({ 
    disabled = false,
    hidden = false,
    onlyOptions = false,
    options = [],
    onClick = () => {},
}) => {
    // Idioma
    const { strings } = useLocalization();
    // Token
    
    // Estados
    const smDown = useMediaQuery(theme => theme.breakpoints.down('sm'));
    const mdUp = useMediaQuery(theme => theme.breakpoints.up('md'));
    // Listas
    
    // Funciones


    // Vista
    return (
        <Fragment>
            {!hidden && (
                <Fragment>
                    {!smDown && options.length === 0 && (
                        <Button 
                            variant="contained" 
                            disableElevation 
                            startIcon={<AddIcon />} 
                            color="primary" 
                            disabled={disabled}
                            onClick={onClick}
                        >
                            {strings.modules.nuevo}
                        </Button>
                    )}
                    {!smDown && options.length > 0 && (
                        <SplitButton
                            buttonText={strings.modules.nuevo}
                            startIcon={<AddIcon />}
                            disabledBtn={disabled}
                            options={options.map((x, i) => ({ id: i+1, option: x }))}
                            onButtonClick={onClick}
                            hiddenBtn={onlyOptions}
                            hiddenOpt={false}
                        />
                    )}
                    {!mdUp && (
                        <FloatingAction
                            icon={<AddIcon />}
                            show={!disabled}
                            onClick={onClick}
                        />
                    )}
                </Fragment>
            )}
        </Fragment>
    );
};
